import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import { AccordianTab } from "./AccordianTab";

const ENTER_KEY = 13;
/**
 * Accordian:
 *  - Generic Accordian component for use
 */
export function Accordian(props) {
  const onSelectTab = (tabId) => () => props.onSelectTab(tabId);

  const onKeyDown = (tabId) => (event) =>
    event.keyCode === ENTER_KEY && props.onSelectTab(tabId);

  const renderTab = (tab) => (
    <AccordianTab
      tabIndex={props.tabIndex}
      key={tab.id}
      label={tab.label}
      description={tab.description}
      open={tab.open}
      onClick={onSelectTab(tab.id)}
      onKeyDown={onKeyDown(tab.id)}
    />
  );

  const className = `${cname.accordian} ${props.className}`;

  return <ul className={className}>{props.allTabs.map(renderTab)}</ul>;
}

Accordian.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * List of tabs and their data to populate accordian
   */
  allTabs: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for the tab
       */
      id: PropTypes.number,
      /**
       * label for the tab
       */
      label: PropTypes.string,
      /**
       * description to display on tab
       */
      description: PropTypes.string,
      /**
       * Boolean to set if tab Open
       */
      open: PropTypes.bool,
    })
  ),
  /**
   * Callback for when a  tab is selected in accordian
   */
  onSelectTab: PropTypes.func,
};

Accordian.defualtProps = {
  allTabs: [],
  className: "",
};
